// File: frontend/src/i18n/calendar.js
// Version: 1.0 (2026-10-16, Wave 1 Translation — Calendar)
// Description: словарь экрана Calendar (EN/RU) и функция перевода.

const EN = {
    'cal.header.title': 'Calendar',
    'cal.header.subtitle': 'Appointments for the window you are currently viewing.',
    'cal.header.back': '← Back to work',
    'cal.nav.prev_week': 'Previous week',
    'cal.nav.next_week': 'Next week',
    'cal.nav.today': 'Today',
    'cal.view.day': 'Day',
    'cal.view.week': 'Week',
    'cal.view.month': 'Month',
    'cal.view.agenda': 'Agenda',
    'cal.action.working_hours': 'Working hours',
    'cal.action.working_hours_tooltip': 'Configure working hours',
    'cal.action.create_appointment': 'Appointment',
    'cal.state.loading': 'Querying Google Calendar for window {start} — {end}…',
    'cal.state.error': 'Could not query Google Calendar for window {start} — {end}: {error}. This does NOT mean there are no appointments.',
    'cal.state.retry': 'Retry',
    'cal.state.empty': 'No entries for window {start} — {end}',
    'cal.filter.title': 'Meeting types filter',
    'cal.filter.all': 'All events',
    'cal.katifi.title': 'Katifi smart schedule',
    'cal.katifi.error': 'How many meetings this week — UNKNOWN: Google Calendar did not respond. Refresh sync before promising an open slot to a client.',
    'cal.katifi.loading': 'Querying Google Calendar for this week\'s appointments…',
    'cal.katifi.none': 'There are currently no scheduled appointments in Google Calendar this week. All slots are open for client bookings.',
    'cal.katifi.counts': 'There are {count} appointments scheduled this week. Katifi is ready to book new clients into open slots.',
    'cal.katifi.book': 'Schedule appointment →',
    'cal.sync.title': 'Google Calendar',
    'cal.sync.tooltip_error': 'Could not query Google Calendar',
    'cal.sync.tooltip_active': 'Sync active',
    'cal.sync.tooltip_required': 'Connection required',
    'cal.sync.syncing': 'Syncing...',
    'cal.sync.failed': 'Query failed',
    'cal.sync.synced': 'Synced',
    'cal.sync.not_connected': 'Not connected',
    'cal.sync.updating': 'Updating...',
    'cal.sync.update_btn': 'Refresh from Google',
    'cal.event.no_title': '(Untitled)',
    'cal.error.load_failed': 'Failed to load Google Calendar',
    'cal.header.badge': 'CALENDAR',
    'cal.modal.tag': 'CONSULTATION DETAILS',
    'cal.modal.date_time': 'Date and time',
    'cal.modal.client_info': 'Client Information',
    'cal.modal.client': 'Client',
    'cal.modal.not_specified': 'Not specified',
    'cal.modal.topic': 'Topic / Practice Area',
    'cal.modal.phone': 'Phone',
    'cal.modal.email': 'Email',
    'cal.modal.meet_title': 'Google Meet video meeting',
    'cal.modal.meet_desc': 'Link for client and attorney connection',
    'cal.modal.meet_join': 'Join',
    'cal.modal.notes': 'Notes / Description',
    'cal.modal.open_gcal': 'Open in Google Calendar',
    'cal.modal.close': 'Close',
    'cal.modal.untitled': '(Untitled)',
};

const RU = {
    'cal.header.title': 'Календарь',
    'cal.header.subtitle': 'Встречи за то окно, которое вы сейчас видите.',
    'cal.header.back': '← Назад к работе',
    'cal.nav.prev_week': 'Предыдущая неделя',
    'cal.nav.next_week': 'Следующая неделя',
    'cal.nav.today': 'Сегодня',
    'cal.view.day': 'День',
    'cal.view.week': 'Неделя',
    'cal.view.month': 'Месяц',
    'cal.view.agenda': 'Повестка',
    'cal.action.working_hours': 'Часы приема',
    'cal.action.working_hours_tooltip': 'Настроить часы приема',
    'cal.action.create_appointment': 'Встреча',
    'cal.state.loading': 'Спрашиваем Google Calendar за окно {start} — {end}…',
    'cal.state.error': 'Не смогли спросить Google Calendar за окно {start} — {end}: {error}. Это НЕ значит, что встреч нет.',
    'cal.state.retry': 'Повторить',
    'cal.state.empty': 'За окно {start} — {end} записей нет',
    'cal.filter.title': 'Фильтр типов встреч',
    'cal.filter.all': 'Все события',
    'cal.katifi.title': 'Умный график Katifi',
    'cal.katifi.error': 'Сколько встреч на этой неделе — НЕ ЗНАЕМ: Google Calendar не ответил. Обновите обмен, прежде чем обещать клиенту свободное окно.',
    'cal.katifi.loading': 'Спрашиваем Google Calendar о встречах этой недели…',
    'cal.katifi.none': 'На этой неделе в Google Calendar пока нет запланированных встреч. Все слоты свободны для записи клиентов.',
    'cal.katifi.counts': 'На этой неделе запланировано {count} встреч. Katifi готова принять новых клиентов в свободные окна.',
    'cal.katifi.book': 'Назначить встречу →',
    'cal.sync.title': 'Google Calendar',
    'cal.sync.tooltip_error': 'Не смогли спросить Google Calendar',
    'cal.sync.tooltip_active': 'Синхронизация активна',
    'cal.sync.tooltip_required': 'Требуется подключение',
    'cal.sync.syncing': 'Идет синхронизация...',
    'cal.sync.failed': 'Не смогли спросить',
    'cal.sync.synced': 'Синхронизировано',
    'cal.sync.not_connected': 'Не подключен',
    'cal.sync.updating': 'Обновление...',
    'cal.sync.update_btn': 'Обновить из Google',
    'cal.event.no_title': '(Без названия)',
    'cal.error.load_failed': 'Ошибка загрузки Google Calendar',
    'cal.header.badge': 'КАЛЕНДАРЬ',
    'cal.modal.tag': 'ДЕТАЛИ КОНСУЛЬТАЦИИ',
    'cal.modal.date_time': 'Дата и время',
    'cal.modal.client_info': 'Информация о клиенте',
    'cal.modal.client': 'Клиент',
    'cal.modal.not_specified': 'Не указан',
    'cal.modal.topic': 'Тема / Направление',
    'cal.modal.phone': 'Телефон',
    'cal.modal.email': 'Email',
    'cal.modal.meet_title': 'Google Meet видеовстреча',
    'cal.modal.meet_desc': 'Ссылка для подключения клиента и адвоката',
    'cal.modal.meet_join': 'Подключиться',
    'cal.modal.notes': 'Заметки / Описание',
    'cal.modal.open_gcal': 'Открыть в Google Calendar',
    'cal.modal.close': 'Закрыть',
    'cal.modal.untitled': '(Без названия)',
};

export const SLOVAR = Object.freeze({ en: Object.freeze(EN), ru: Object.freeze(RU) });

export function perevesti(lang, key, vars) {
    const slovar = SLOVAR[lang];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) return `[${key}]`;
    const shablon = slovar[key];
    if (!vars || typeof vars !== 'object') return shablon;
    return shablon.replace(/\{([a-zA-Z]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(vars, imya) && vars[imya] !== undefined && vars[imya] !== null
            ? String(vars[imya])
            : celoe
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
